import { Container, Graphics, Text } from 'pixi.js';

import type { ActiveEvent } from '../engine/world/types';

export class EventTicker {
  readonly root = new Container();
  private readonly background = new Graphics();
  private readonly clip = new Graphics();
  private panelHeight = 112;
  private titleLimit = 42;
  private readonly text = new Text({
    text: '',
    style: {
      fill: '#f0e2b4',
      fontFamily: 'Georgia, serif',
      fontSize: 18,
      lineHeight: 25,
      stroke: { color: '#140d04', width: 4 },
      wordWrap: true,
      wordWrapWidth: 322,
      breakWords: true,
    },
  });

  constructor() {
    this.root.addChild(this.background, this.text, this.clip);
    this.root.position.set(1512, 28);
    this.text.position.set(14, 12);
    this.background.rect(0, 0, 360, 112).fill({ color: 0x10170c, alpha: 0.78 }).stroke({ color: 0xb8852c, width: 2 });
    this.clip.rect(8, 8, 344, 96).fill(0xffffff);
    this.text.mask = this.clip;
  }

  setPolishMode(): void {
    this.root.position.set(1582, 22);
    this.panelHeight = 122;
    this.titleLimit = 34;
    this.text.style.fontSize = 16;
    this.text.style.lineHeight = 21;
    this.text.style.wordWrapWidth = 270;
    this.background.clear();
    this.background.rect(0, 0, 300, 122).fill({ color: 0x0b1208, alpha: 0.66 }).stroke({ color: 0xc79638, width: 2 });
    this.clip.clear();
    this.clip.rect(8, 8, 284, 106).fill(0xffffff);
  }

  update(events: readonly ActiveEvent[]): void {
    const lines = ['Ereignisse'];
    const availableHeight = this.panelHeight - 24;

    for (const event of events.slice(0, 3)) {
      const nextLine = `- ${this.shortTitle(event.title)}`;
      this.text.text = [...lines, nextLine].join('\n');
      if (this.text.height > availableHeight) {
        break;
      }
      lines.push(nextLine);
    }

    this.text.text = lines.join('\n');
  }

  private shortTitle(title: string): string {
    const normalized = title.replace(/\s+/g, ' ').trim();
    return normalized.length > this.titleLimit
      ? `${normalized.slice(0, this.titleLimit - 3).trim()}...`
      : normalized;
  }
}
